import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DARK_THEME_PRIMARY } from "constants/";
import { TenantBrandingDetails, TenantState } from "features/types";
import { RootState } from "store";
import { removeStoredTenantSubdomain } from "utils/storageUtils";

const initialState: TenantState = {
  tenantThemeColor: DARK_THEME_PRIMARY,
  tenantSecondaryColor: "",
  tenantSubdomain: null,
  tenantType: null,
};

export const tenantSlice = createSlice({
  name: "tenant",
  initialState,
  reducers: {
    initTenantSubdomainAndType: (
      state,
      action: PayloadAction<TenantBrandingDetails>
    ) => {
      state.tenantSubdomain = action.payload.subdomain;
      state.tenantType = action.payload.type;
      state.tenantThemeColor = action.payload.primaryColor;
      state.tenantSecondaryColor = action.payload.secondaryColor;
    },
    resetTenantState: (state) => {
      state.tenantSubdomain = initialState.tenantSubdomain;
      state.tenantType = initialState.tenantType;
      state.tenantThemeColor = initialState.tenantThemeColor;
      state.tenantSecondaryColor = initialState.tenantSecondaryColor;
      removeStoredTenantSubdomain();
    },
  },
});

export const { initTenantSubdomainAndType, resetTenantState } =
  tenantSlice.actions;

// export const selectTenantConfig = (state: RootState) =>
//   state.tenant.tenantConfig;
export const selectThemeColor = (state: RootState) =>
  state.tenant.tenantThemeColor;
export default tenantSlice.reducer;
